import request from '../../utils/request'
import { UrlSearch } from "../../utils/UrlSearch";
const shopTitle = UrlSearch().shop;
let shopName ;
if(shopTitle){
  let index = shopTitle.indexOf('.');
  if(index>0){
      shopName = shopTitle.substring(0,index);
  }else{
      shopName = shopTitle;
  }

}

export function getrulelist(param) {
    param.shopName = shopName;
  return request({
    url: `get-rule-list`,
    method: 'post',
    params: param
  })
}
export function changerulestatus(param) {
    param.shopName = shopName;
return request({
  url: `change-rule-status`,
  method: 'post',
  params: param
})
}

export function getruletype() {
  let param={}
  param.shopName = shopName;
return request({
  url: `get-rule-type`,
  method: 'post',
  params: param
})
}

export function getcolvals(param) {
    param.shopName = shopName;
return request({
  url: `get-colvals`,
  method: 'post',
  params: param
})
}

export function getshippriority() {
  let param={}
  param.shopName = shopName;
    
return request({
  url: `get-ship-priority`,
  method: 'post',
  params: param
})
}
export function addrule(param) {
    param.shopName = shopName;
return request({
  url: `add-rule`,
  method: 'post',
  params: param
})
}


export function getrulecolsmap(param) {
    param.shopName = shopName;
return request({
  url: `get-rule-cols-map`,
  method: 'post',
  params: param
})
}

export function editcolsmap(param) {
    param.shopName = shopName;
return request({
  url: `edit-cols-map`,
  method: 'post',
  params: param
})
}

export function recommendshipmethod(param) {
    param.shopName = shopName;
return request({
  url: `recommend-shipmethod`,
  method: 'post',
  params: param
})
}









// WEBPACK FOOTER //
// ./src/components/views/api/setting.js